import { AxiosResponse } from 'axios';

import Resolver from 'src/common/Resolver';
import usePageContentsStore from 'src/stores/pageContentsStore';
import usePublicPagesStore from 'src/stores/publicPagesStore';
import useTrackMapsStore from 'src/stores/trackMapsStore';
import PageEditor from './PageEditor';

const PageEditorResolver = () => {
  const { fetchPublicPages } = usePublicPagesStore(s => s);
  const { fetchPageContents } = usePageContentsStore(s => s);
  const { fetchTrackMaps } = useTrackMapsStore(s => s);

  const loadDependencies = () =>
    Promise.all([
      fetchPublicPages(),
      fetchPageContents(),
      fetchTrackMaps(),
    ] as Array<Promise<void | AxiosResponse<unknown>>>);

  return <Resolver resolve={loadDependencies} successComponent={PageEditor} />;
};

export default PageEditorResolver;
